import { createI18n } from 'vue-i18n'
import cn from './cn.js'
import en from './en.js'

const i18n = createI18n({
  legacy: false,
  locale: 'cn',
  fallbackLocale: 'cn',
  messages: {
    cn,
    en
  }
})

export default i18n